<template>
    <div class="form-body">
        <div class="text-24 text-tc-blue-2 text-center">
            {{lbl.profile.edit_profile}}
        </div>
        <div class="px-5px pt-4">
            <InputRadioInline
                class="mb-3 text-20"
                v-model:inputValue="formData.nationality"
                :inputLbl="lbl.register.nationality"
                :itemList="nationalityList"
                :errorInfo="errorInfo[0]"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :isShowStar="true"
            ></InputRadioInline>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-3">
            <div class="px-5px" v-if="isThaiNational">
                <InputNationalId
                    ref="input-cardId"
                    v-model:inputValue="formData.idcard"
                    :inputLbl="lbl.register.id_card"
                    :errorInfo="errorInfo[1]"
                    :maxLength="13"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                    :isFirstSave="isFirstSave"
                    :isDisabled="true"
                ></InputNationalId>
            </div>
            <div class="px-5px" v-else>
                <InputText
                    ref="input-passport"
                    v-model:inputValue="formData.passport"
                    :inputLbl="lbl.register.passport"
                    :errorInfo="errorInfo[1]"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                    :isDisabled="true">
                </InputText>
            </div>
            <div class="px-5px">
                <InputText
                    v-model:inputValue="formData.firstName"
                    :inputLbl="lbl.register.form.firstname"
                    :errorInfo="errorInfo[2]"
                    :maxLength="50"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                    :isFirstSave="isFirstSave"
                    :isDisabled="true"
                ></InputText>
            </div>
            <div class="px-5px">
                <InputText
                    v-model:inputValue="formData.lastName"
                    :inputLbl="lbl.register.form.lastname"
                    :errorInfo="errorInfo[3]"
                    :maxLength="50"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                    :isFirstSave="isFirstSave"
                    :isDisabled="true"
                ></InputText>
            </div>
            <div class="px-5px">
                <InputRadio
                    v-model:inputValue="formData.gender"
                    :inputLbl="lbl.register.form.gender"
                    :itemList="genderList"
                    :errorInfo="errorInfo[4]"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                ></InputRadio>
            </div>
            <div class="px-5px">
                <InputContactNumber
                    v-model:inputValue="formData.contact_number"
                    delimeter="-"
                    :minLength="12"
                    :maxLength="12"
                    :errorInfo="errorInfo[5]"
                    :isShowErrorLbl="true"
                    :inputLbl="lbl.register.form.phone"
                    :isShowStar='true'
                    :isFirstSave="isFirstSave"
                    :isDisabled="false"
                ></InputContactNumber>
            </div>
            <div class="px-5px">
                <InputEmail
                    v-model:inputValue="formData.email"
                    :inputLbl="lbl.register.form.email"
                    :errorInfo="errorInfo[6]"
                    :maxLength="50"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                    :isFirstSave="isFirstSave"
                ></InputEmail>
            </div>
        </div>
         <div class="grid grid-cols-1 sm:grid-cols-3">
            <div class="px-5px">
                <InputRadio
                    v-model:inputValue="formData.password_type"
                    :inputLbl="lbl.register.form.passwordFormat"
                    :itemList="formatPasswordList"
                    :errorInfo="errorInfo[7]"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                ></InputRadio>
            </div>
        </div>
         <div v-if="formData.password_type === 'pin'">
            <PinFormat
                :form="formData"
                :isEdit="true"
                :errorInfo="errorPin"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="false"
            />
        </div>
        <div v-else>
            <PasswordFormat
                :form="formData"
                :isEdit="true"
                :errorInfo="errorPassword"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="false"
            />
        </div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import InputText from "@/components/Input/label/InputText.vue";
import InputNationalId from "@/components/Input/label/InputNationalId.vue";
import InputContactNumber from "@/components/Input/label/InputContactNumber.vue";
import InputEmail from "@/components/Input/label/InputEmail.vue";
import InputRadio from "@/components/Input/label/InputRadioInline.vue";
import PasswordFormat from "@/module/EditProfile/component/PasswordFormat/Password.vue";
import InputRadioInline from "@/components/Input/label/InputRadioInline.vue";
import PinFormat from "@/module/EditProfile/component/PasswordFormat/Pin.vue"
import { FormHelper } from "@/helper/FormHelper.js"; //from helper
import { RegisterModel,ValidateForm } from '@/core/Account/model/RegisterModel';

export default {
    name: 'FormEditProfile',
    mixins: [LocaleMixin],
    components:{
        InputText,
        InputNationalId,
        InputContactNumber,
        InputEmail,
        InputRadio,
        InputRadioInline,
        PasswordFormat,
        PinFormat,
    },
    props:{
        form: Object,
        controller: Object,
    },
    data() {
        return {
            formData: null,
            errorInfo: [],
            errorPassword: [],
            errorPin: [],
            genderList: new RegisterModel().setGenderList(),
            nationalityList: new RegisterModel().setNationalityList(),
            formatPasswordList: new RegisterModel().setFormatPassword(),
            isFirstSave: true,
        };
    },
    computed: {
        isThaiNational: function(){
            if(this.formData.nationality == 'thai'){
                return true
            }
            return false
        }
    },
    created() {
        this.formData = this.form
        this.errorInfo = FormHelper.genErrorInfo(8);
        this.errorPassword = FormHelper.genErrorInfo(2);
        this.errorPin = FormHelper.genErrorInfo(2);
    },
    methods: {
        validateRegisterForm: function(){
            this.isFirstSave = false;
            let validate = new ValidateForm()
            const validateInput = validate.validateForm(this.errorInfo);
            const validatePasswordType = validate.validatePasswordType(this.formData , this.errorPin , this.errorPassword);
            const validateMatchPassword = validate.validateMatchPassword(this.formData);
            const checkFormatPassword = validate.checkFormatPassword(this.formData);
            this.lbl.register.id_card.required = '';
            this.lbl.register.id_card.too_short = '';
            this.lbl.register.passport.required = '';
            this.lbl.register.passport.too_short = '';
            if(this.formData.nationality === 'thai'){ //ไทย
                this.lbl.register.id_card.required = 'กรุณากรอกรหัสบัตรประชาชน 13 หลัก';
                this.lbl.register.id_card.too_short = 'กรุณากรอกรหัสบัตรประชาชน 13 หลัก';
                this.$refs['input-cardId'].validateInput();

            }else {
                this.lbl.register.passport.required = 'กรุณากรอกเลขพาสปอร์ต 7 หลัก';
                this.lbl.register.passport.too_short = 'กรุณากรอกเลขพาสปอร์ต 7 หลัก';
                this.$refs['input-passport'].validateInput();
            }
            //validate
            if(!validateInput){
                return { pass: false, msg: this.lbl.home.input_field }
            }else if(!validatePasswordType){
                return { pass: false, msg: this.lbl.home.password_format }
            }else if(!validateMatchPassword){
                return { pass: false, msg: this.lbl.home.password_not_match }
            }else if(!checkFormatPassword){
                return { pass: false, msg: this.lbl.register.form.passwordFormatText }
            } else{
                if (this.formData.password_type === 'pin') {
                    this.formData.password = this.formData.pin;
                }
                return { pass: true, msg: ''}
            }
        },
    },
};
</script>

<style lang="scss" scoped>
  .form-body {
        margin: auto;
        max-width: 800px;
  }
</style>
